import { render, staticRenderFns } from "./VideoActions.vue?vue&type=template&id=d56fb340&"
import script from "./VideoActions.vue?vue&type=script&lang=js&"
export * from "./VideoActions.vue?vue&type=script&lang=js&"
import style0 from "./VideoActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports